import { render, staticRenderFns } from "./searchSelect.vue?vue&type=template&id=24824f63"
import script from "./searchSelect.vue?vue&type=script&lang=js"
export * from "./searchSelect.vue?vue&type=script&lang=js"
import style0 from "./searchSelect.vue?vue&type=style&index=0&id=24824f63&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports